import React from "react";
import Logo from "../../../Assests/Images/Logo.svg";

const CHUNK_ERROR_RELOAD_KEY = "canary_chunk_error_reloaded";

function isChunkError(msg) {
  return (
    msg.includes("chunk") ||
    msg.includes("Loading CSS") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("Unable to preload CSS")
  );
}

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false, autoReloading: false };
  }

  static getDerivedStateFromError(error) {
    const msg = error?.message || "";
    const chunkErr = isChunkError(msg);
    const alreadyReloaded = sessionStorage.getItem(CHUNK_ERROR_RELOAD_KEY) === "1";

    if (chunkErr && !alreadyReloaded) {
      return { hasError: true, isChunkError: true, autoReloading: true };
    }

    return { hasError: true, isChunkError: chunkErr, autoReloading: false };
  }

  componentDidCatch() {
    if (this.state.autoReloading) {
      sessionStorage.setItem(CHUNK_ERROR_RELOAD_KEY, "1");
      window.location.reload();
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    if (this.state.autoReloading) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            background: "#FAFAF7",
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "3px solid #E8D5A0",
              borderTopColor: "#C9A84C",
              animation: "spin 0.8s linear infinite",
            }}
          />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "32px 24px",
          background: "#FAFAF7",
          fontFamily: "Montserrat, sans-serif",
          textAlign: "center",
          gap: "24px",
        }}
      >
        <img src={Logo} alt="Canary" style={{ height: 40 }} />
        <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1A1A1A", margin: 0 }}>
          {this.state.isChunkError ? "App updated — please refresh" : "Something went wrong"}
        </h2>
        <p style={{ fontSize: 14, fontWeight: 500, color: "#6B7280", margin: 0, maxWidth: 360 }}>
          {this.state.isChunkError
            ? "A new version of the app is available. Refreshing the page will load the latest version."
            : "An unexpected error occurred. Please reload the page or contact support if the problem persists."}
        </p>
        <button
          onClick={() => {
            sessionStorage.removeItem(CHUNK_ERROR_RELOAD_KEY);
            window.location.reload();
          }}
          style={{
            background: "#C9A84C",
            color: "#FFFFFF",
            border: "none",
            borderRadius: 100,
            padding: "12px 32px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Reload Page
        </button>
      </div>
    );
  }
}

export default AppErrorBoundary;
